import { styled, Typography } from "@mui/material";

export const FormFieldMessage = styled(Typography)(() => ({
  marginTop: "1rem",
}));
